import React, { useEffect, useState } from "react";
import "./Categories.css";
import { Nav, Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCategories,
  getAllChildCategory,
  HighLowPrice,
} from "../../features/master/masterSlice";
import { getAllProducts } from "../../features/products/productsSlice";
import { useLocation, useParams } from "react-router-dom";
import Top_Filter_Div from "./top_filter_div/Top_Filter_Div";
import Category_Slider from "./category_slider/Category_Slider";
import Common_Product_Card from "../common_components/common_product_card/Common_Product_Card";
import Black_Btn from "../common_components/common_btn/Black_Btn/Black_Btn";
import { variant_type } from "../../utils/common";

const Categories = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedOption, setSelectedOption] = useState(null);
  const [showMore, setShowMore] = useState(null);
  const location = useLocation();
  const [categoryId, setCategoryId] = useState(null);
  const searchParams = new URLSearchParams(location.search);
  const categoryName = searchParams.get("category_name");
  const subcategory_id = searchParams.get("sub_category_id");
  const categoryImage = searchParams.get("category_image");
  const subcategoryname = searchParams.get("subcategory_name");

  const highlowprice = useSelector((state) => state.master.high_low_price);
  const [activeSize, setActiveSize] = useState([]);
  const [activeMattress, setActiveMattress] = useState([]);
  const [activeHeight, setActiveHeight] = useState([]);

  const dispatch = useDispatch();
  const [discount, setDiscount] = useState();
  useEffect(() => {
    dispatch(HighLowPrice());
  }, [dispatch]);
  const [priceRange, setPriceRange] = useState([0, 0]);

  useEffect(() => {
    if (highlowprice) {
      setPriceRange([
        Number(highlowprice?.lowest_price) || 0,
        Number(highlowprice?.highest_price) || 0,
      ]);
    }
  }, [highlowprice]);
  const { id } = useParams();

  const queryParams = new URLSearchParams(location.search);
  const searchValue = queryParams.get("search");
  const shapeId = searchParams.get("shape_id");
  const name = searchParams.get("name");
  useEffect(() => {
    setCategoryId(id);
  }, [id]);
  const allProducts = useSelector((state) => state.product.allProducts);
  useEffect(() => {
    dispatch(
      getAllProducts({
        name: searchValue,
        category_id: categoryId,
        subcategory_id: subcategory_id,
        height_id: activeHeight || "",
        size_id: activeSize || "",
        mattress_id: activeMattress || "",
        priceOrder: priceRange || "",
        sortBy: selectedOption || "",
        page: currentPage || 1,
        discount: discount || "",
        shape_id: shapeId || "",
        per_page: 10,
      }),
    );
  }, [
    dispatch,
    selectedOption,
    searchValue,
    categoryId,
    priceRange,
    selectedOption,
    activeSize,
    activeHeight,
    activeMattress,
    discount,
    selectedOption,
    currentPage,
    shapeId,
  ]);

  const categoriesData = useSelector((state) => state.master.categories);

  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch, id]);

  const totalPages = Math.max(allProducts?.total_pages || 0);
  const handlePageChange = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setCurrentPage(pageNum);
    }
  };
  console.log(name, "name name");

  return (
    <section className="Product_Listing_Page">
      <Tab.Container id="left-tabs-example" defaultActiveKey="Grid">
        <Top_Filter_Div
          setDiscount={setDiscount}
          discount={discount}
          priceRange={priceRange}
          setPriceRange={setPriceRange}
          pageTitle={name || categoryName}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
          setActiveMattress={setActiveMattress}
          activeMattress={activeMattress}
          activeSize={activeSize}
          setActiveSize={setActiveSize}
          setActiveHeight={setActiveHeight}
          activeHeight={activeHeight}
        />

        <div className="container">
          <Category_Slider
            categoryImage={categoryImage}
            subcategoryname={subcategoryname}
            categoryId={id}
            subCategoryId={categoryId}
            show={true}
            subcategory_id={id}
            categories={categoriesData}
            setSubCategoryId={setCategoryId}
          />

          <div className="all_cats_div">
            <div className="row">
              {allProducts?.data?.length > 0 ? (
                allProducts?.data?.map((product) => {
                  let metal;
                  let size;
                  let triple;
                  if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Single)
                  ) {
                    metal = product?.Product_Variants?.[0];
                  } else if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Double)
                  ) {
                    metal = product?.Product_Variants?.[0];
                    size = metal?.Double_Variants?.[0];
                  } else if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Triple)
                  ) {
                    metal = product?.Product_Variants?.[0];
                    size = metal?.Double_Variants?.[0];
                    triple = size?.Triple_Variants?.[0];
                  }

                  const activeVariant = triple || size || metal;

                  return (
                    <div
                      key={product?.id}
                      className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 mb-5 custom_col"
                    >
                      <Common_Product_Card
                        product={product}
                        id={product.id}
                        imgSrc={process.env.REACT_APP_IMG_URL + product.image}
                        vdoSrc={process.env.REACT_APP_IMG_URL + product.video}
                        productName={product.name}
                        sellingPrice={activeVariant?.price || 0}
                        mrp={activeVariant?.mrp || 0}
                        kgText={metal?.Metal?.name}
                        discount={
                          activeVariant?.mrp
                            ? (
                                ((parseFloat(activeVariant?.mrp || 0) -
                                  parseFloat(activeVariant?.price || 0)) /
                                  parseFloat(activeVariant?.mrp || 1)) *
                                100
                              ).toFixed(0)
                            : 0
                        }
                        feature={product?.Product_Fetures}
                        btnText={"View Details"}
                      />
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    fontWeight: "bold",
                    width: "100%",
                  }}
                >
                  Product Not Available
                </div>
              )}
            </div>
            <div className="pagination mt-4 d-flex justify-content-center align-items-center gap-2">
              <button
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
              >
                &laquo;
              </button>
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                &lsaquo;
              </button>

              {/* Always show first two pages */}
              {[currentPage].map((page) => (
                <button
                  key={page}
                  onClick={() => handlePageChange(page)}
                  className={page === currentPage ? "active" : ""}
                >
                  {page}
                </button>
              ))}
              {/* Show ... if there are more than 3 pages */}
              {totalPages > 3 && (
                <>
                  <span>...</span>

                  {/* Show last page */}
                  <button
                    onClick={() => handlePageChange(totalPages)}
                    className={currentPage === totalPages ? "active" : ""}
                  >
                    {totalPages}
                  </button>
                </>
              )}

              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                &rsaquo;
              </button>
              <button
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages}
              >
                &raquo;
              </button>
            </div>

            {/* {allProducts?.data?.data?.length > 0 ? (
              <div className="view_more_btn">
                {showMore ? (
                  <Black_Btn
                    btnText={"View Less"}
                    onClick={() => {
                      setShowMore(false);
                    }}
                  />
                ) : (
                  <Black_Btn
                    btnText={"View More"}
                    onClick={() => {
                      setShowMore(true);
                    }}
                  />
                )}
              </div>
            ) : null} */}
          </div>
        </div>
      </Tab.Container>
    </section>
  );
};

export default Categories;
